import axios, { AxiosInstance } from "axios";
import { Config } from "../../config";

const config = new Config();

const createApiInstance = (baseURL: string): AxiosInstance => {
  return axios.create({ baseURL });
};

const AgentApi = createApiInstance(config.settings.AgentApiUrl);

// Calls that used to attach a bundled bearer for the App, Hub or Accounts API now go
// through the BFF, which holds those tokens server-side. These routes stay
// unauthenticated because the candidate chat widget is public and is served from
// several customer domains.
const BffPublicApi = createApiInstance(`${config.settings.BffApiUrl}public/`);

export const startAgentChat = async (payload: any, initiate: boolean = false, version: string = "") => {
  const res = await AgentApi.post(initiate ? (version === 'v1'? "agent_start/": "candidate/chatbot/initialize") : (version === 'v1'? "chat/": "candidate/chatbot/run"), payload);
  return res.data;
};

export const endAgentChat = async (payload: any, version: string = "") => {
  const res = await AgentApi.post((version === 'v1'? "agent_end/": "candidate/chatbot/end"), payload);
  return res.data;
};

export const submitConsent = async (payload: any, version: string = "") => {
  const res = await AgentApi.post(version === 'v1'? "consent/": "compliance/user_consent/", payload);
  return res.data;
};

export const getSessionInfoByAI = async (payload: any) => {
  const res = await BffPublicApi.post(`session-info/ai`, { sessionId: payload?.sessionId });
  return res.data;
}

export const getSessionInfoByHub = async (uniqueId: any) => {
  const res = await BffPublicApi.get(`session-info/hub/${encodeURIComponent(uniqueId)}`);
  return res.data;
}

export const getUrlSettings = async (key: string, domainName: string) => {
  const res = await BffPublicApi.get(`url-setting`, { params: { key, domainName } });
  return res.data;
}

export const getBrandDetails = async (clientCode: string) => {
  const res = await BffPublicApi.get(`brand/${encodeURIComponent(clientCode)}`);
  return res.data;
}

export const getTimeZoneList = async () => {
  const res = await BffPublicApi.get(`timezones`);
  return res.data;
}

export const getAppointmentSlots = async (payload: any) => {
  const res = await BffPublicApi.post(`appointment-slots`, payload);
  return res.data;
}
